import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { Input, Button, Form, message } from "antd";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";
import { purgeStoredState } from "redux-persist";

import Fetch from "components/Fetch";
import colors from "constants/palette";

export default function Login() {
  const history = useHistory();
  const cookies = new Cookies();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = cookies.get("__token");
    if (token) {
      console.log("zzzzzzz", token);
      Fetch.check(token, (res) => {
        if (res?.data?.user.id) {
          message.success("با موفقیت وارد شدید");
          history.push("/dashboard/index");
        }
      });
    }
    // eslint-disable-next-line
  }, []);

  const onSubmit = (data) => {
    setLoading(true);

    //clear everything
    cookies.remove("__token", { path: "/" });
    cookies.remove("info", { path: "/" });

    console.log("submit data", data);
    try {
      Fetch.post(
        "/login",
        data,
        (res) => {
          console.log("login response", res);
          if (res.token) {
            cookies.set("__token", res.token, { path: "/" });
            cookies.set("info", JSON.stringify(res.data), { path: "/" });
            // console.log(cookies.get("__token"));
            message.success("با موفقیت وارد شدید");

            window.location.replace("/dashboard/index");
          } else {
            console.log(res);
            if (res.error) {
              message.error("اطلاعات وارد شده صحیح نمی‌باشد");
            }
            res.message?.phone && message.error(res.message.phone);
            res.message?.password && message.error(res.message.password);
          }
          setLoading(false);
        },
        (error) => {
          console.log("login error", error);
          setLoading(false);
        }
      );
    } catch (error) {
      console.log("login error", error);
      setLoading(false);
    }
  };

  return (
    <>
      <Form onFinish={onSubmit}>
        <h1>ورود</h1>
        <Form.Item
          name="phone"
          rules={[{ required: true, message: "لطفا تلفن خود را وارد کنید!" }]}
        >
          <Input
            size="large"
            placeholder="تلفن"
            suffix={<UserOutlined />}
            style={{ marginTop: 32 }}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            { required: true, message: "لطفا رمز عبور خود را وارد کنید!" },
          ]}
        >
          <Input
            size="large"
            placeholder="رمز عبور"
            suffix={<KeyOutlined />}
            style={{ marginTop: 32 }}
            type="password"
          />
        </Form.Item>

        <Button
          shape="round"
          size={"large"}
          style={{
            marginTop: 22,
            background: colors.secondary,
            border: "none",
            color: "#fff",
          }}
          htmlType="submit"
          loading={loading}
        >
          <span style={{ padding: "0 12px" }}>ورود</span>
        </Button>
      </Form>
    </>
  );
}
